import { createAction } from '@reduxjs/toolkit';
import { Tag } from '../../../general/model';

export const tagsButtonClicked = createAction<void, 'creativeHub/tag/tagsButtonClicked'>(
  'creativeHub/tag/tagsButtonClicked',
);

export const setIsOpen = createAction<{ isOpen: boolean }, 'creativeHub/tag/setIsOpen'>(
  'creativeHub/tag/setIsOpen',
);

export const setIsApplying = createAction<{ isApplying: boolean }, 'creativeHub/tag/setIsApplying'>(
  'creativeHub/tag/setIsApplying',
);

export const modalInitialized = createAction<
  { tagsLoaded: Tag[] },
  'creativeHub/tag/modalInitialized'
>('creativeHub/tag/modalInitialized');

export const modalActionButtonClicked = createAction<
  { button: 'ok' | 'cancel' },
  'creativeHub/tag/modalActionButtonClicked'
>('creativeHub/tag/modalActionButtonClicked');

export const tagsSelected = createAction<{ tags: Tag[] }, 'creativeHub/tag/tagsSelected'>(
  'creativeHub/tag/tagsSelected',
);

export const searchTextChanged = createAction<
  { searchText: string },
  'creativeHub/tag/searchTextChanged'
>('creativeHub/tag/searchTextChanged');

export const checkboxChanged = createAction<
  { recursive: boolean },
  'creativeHub/tag/checkboxChanged'
>('creativeHub/tag/checkboxChanged');

export const nodeTagsPatched = createAction<
  { nodeID: number; tags: Tag[] },
  'creativeHub/tag/nodeTagsPatched'
>('creativeHub/tag/nodeTagsPatched');
